import { render, staticRenderFns } from "./LeaveRequestDetail.vue?vue&type=template&id=2b7d36e4&"
import script from "./LeaveRequestDetail.vue?vue&type=script&lang=js&"
export * from "./LeaveRequestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports